<template>
  <section>
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon>Registro de Solicitudes
    </h3>
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>Solicitudes del Dia</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="700px" persistent scrollable>
          <v-btn slot="activator" fab dark color="primary" class="mb-2">
            <v-icon dark>add</v-icon>
          </v-btn>
          <v-card>
            <v-card-title class="headline grey lighten-3 mb-0" primary-title>
              {{ formTitle }}
              <v-spacer></v-spacer>
              <v-btn color="error" icon flat @click="close">
                <v-icon color="error">close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pa-0" >  
              <v-stepper v-model="paso">
                <v-stepper-header>
                  <v-stepper-step :complete="paso > 1" step="1">Red SAJ</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="paso > 2" step="2">Datos del Caso</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-card>
                      <v-card-text class="pt-0">
                        <v-form ref="formRedSaj" v-model="valid" lazy-validation>
                          <v-container grid-list-xs>
                            <v-layout row wrap align-center justify-center fill-height>
                              <v-flex xs12 lg12 text-lg-center>
                                ¿Cuenta con código generado por la Red SAJ?
                              </v-flex>  
                              <v-flex xs12 lg8 offset-lg5>
                                <v-radio-group v-model="editedItem.conCodigoSaj" row>
                                  <v-radio label="SI" :value="true"></v-radio>
                                  <v-radio label="NO" :value="false"></v-radio>
                                </v-radio-group>
                              </v-flex>   
                              <v-flex xs12 lg7 v-if="editedItem.conCodigoSaj" class="pb-0">
                                <v-text-field
                                  label="Código Red SAJ"
                                  placeholder="Ingrese el codigo generado por la red SAJ"
                                  outline
                                  class="required"
                                  v-model="editedItem.codigoSaj"
                                  :rules="ruleCodigoSaj"
                                  :readonly="!!editedItem.idSucursal"
                                  @keypress.enter.prevent="consultarRedSaj"
                                >
                                  <template slot="prepend-inner">
                                    <v-icon>search</v-icon>
                                  </template>
                                  <template slot="append" v-if="editedItem.idSucursal">
                                    <v-btn color="error" flat icon @click="limpiarCodigo">
                                      <v-icon color="error">delete</v-icon>
                                    </v-btn>
                                  </template>
                                </v-text-field>                    
                              </v-flex>
                              <v-flex xs12 lg11 v-if="editedItem.reasignacion">
                                  <v-alert :value="true" type="warning">
                                    La entidad asignada por la Gestora SAJ es diferente a tu entidad, en caso de continuar debes seleccionar información de tu sucursal y justificar la recepción
                                  </v-alert>
                              </v-flex>
                              <v-flex xs12 lg11 v-if="editedItem.idSucursal" class="pt-0">
                                <p class="text-xs-center font-weight-bold primary--text subheading">ENTIDAD DESIGNADA POR SAJ</p>
                                <v-list class="py-0">
                                  <v-list-tile v-if="editedItem.reasignacion" class="mb-2">
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title class="font-weight-bold primary--text">Entidad Asignada</v-list-tile-sub-title>
                                      <v-list-tile-title v-if="editedItem.entidad">{{ editedItem.entidad.sigla }} - {{ editedItem.entidad.nombre }}</v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile v-if="editedItem.sucursalAsignada" class="mb-2">
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title class="font-weight-bold primary--text">Sucursal Asignada</v-list-tile-sub-title>
                                      <v-list-tile-title v-if="editedItem.sucursalAsignada">{{ editedItem.sucursalAsignada.nombre }}</v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile v-if="editedItem.sucursalAsignada" class="mb-2">
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title class="font-weight-bold primary--text">Direccion Sucursal</v-list-tile-sub-title>
                                      <v-list-tile-title v-if="editedItem.sucursalAsignada" line>{{ editedItem.sucursalAsignada.direccion }}</v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile class="mb-2">
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title class="font-weight-bold primary--text">Servicio</v-list-tile-sub-title>
                                      <v-list-tile-title v-if="editedItem.servicio">{{ editedItem.servicio.servicio.nombre }}</v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile class="mb-2">
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title class="font-weight-bold primary--text">Materia</v-list-tile-sub-title>
                                      <v-list-tile-title v-if="editedItem.servicio">{{ editedItem.servicio.materia }}</v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile class="mb-2">
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title class="font-weight-bold primary--text">Reseña Caso</v-list-tile-sub-title>
                                      <v-list-tile-title>{{ editedItem.descripcion_hecho}}</v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-list>
                              </v-flex>
                              <v-flex xs12 v-if="editedItem.idSucursal">
                                 <p class="text-xs-center font-weight-bold primary--text subheading">SUCURSAL RECEPTORA</p>
                              </v-flex>
                              <v-flex xs12 lg11 v-if="editedItem.idSucursal" >
                                <v-select
                                  :items="sucursales"
                                  v-model="editedItem.sucursal"
                                  :label="editedItem.sucursal?'Nombre Sucursal':'Selecciona una sucursal'"
                                  item-text="nombre"
                                  item-value="id"
                                  return-object
                                  class="py-1 mx-3 required"
                                  :rules="ruleSucursal"
                                ></v-select>
                              </v-flex>
                              <!-- <v-flex xs12 lg10 v-if="editedItem.idSucursal" >
                                <v-list two-line subheader>
                                <v-list-tile avatar v-if="editedItem.sucursal">
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Direccion Sucursal</v-list-tile-sub-title>
                                    <v-list-tile-title>{{ editedItem.sucursal.direccion }}</v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                </v-list>
                              </v-flex>  -->
                              <v-flex xs12 lg11 v-if="editedItem.reasignacion">                 
                                <v-textarea
                                  class="py-1 mx-3 required"
                                  label="Justifiacion"
                                  placeholder="Ingrese justificacion para la recepción del caso"
                                  auto-grow
                                  rows="1"
                                  v-model="editedItem.justificacionRecepcion"
                                  :rules="ruleJustificacion"
                                />
                              </v-flex>
                            </v-layout>
                          </v-container>
                          </v-form>
                      </v-card-text>
                      <v-card-actions aligin="rigth">
                        <v-spacer></v-spacer>
                        <v-btn @click.native="close" flat color="error">Cancelar</v-btn>
                        <v-btn v-if="editedItem.conCodigoSaj && !editedItem.sucursal" dark color="indigo darken-4" @click="consultarRedSaj">
                          <v-icon class="mr-2">search</v-icon> CONSULTAR
                        </v-btn>
                        <v-btn v-if="!editedItem.conCodigoSaj || editedItem.sucursal" color="primary" @click="consultarRedSaj">
                          CONTINUAR <v-icon class="ml-2">arrow_forward_ios</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>


                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-card>
                      <v-card-text class="pa-0">  
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md4>
                                <v-text-field
                                  v-model="editedItem.ci"
                                  label="CI Solicitante"
                                  :rules="[v => !!v || 'Nro. documento es requerido']"
                                  required
                                  maxlength="20"
                                  @keydown.native="$filter.numeric($event)"
                                  :counter="12"
                                  class="required"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-text-field
                                  v-model="editedItem.nombres"
                                  label="Nombres Solicitante"
                                  :rules="[v => !!v || 'nombre es requerido']"
                                  required
                                  class="required"
                                  maxlength="30"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-text-field
                                  v-model="editedItem.primer_apellido"
                                  label="Primer apellido solicitante"
                                  :rules="[v => !!v || 'nombre es requerido']"
                                  required
                                  class="required"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-text-field
                                  v-model="editedItem.segundo_apellido"
                                  label="Segundo apellido solicitantes"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-select
                                  v-model="select_nacionalidad"
                                  :items="nacionalidad"
                                  item-text="valor"
                                  item-value="clave"
                                  label="Nacionaldad"
                                  persistent-hint
                                  return-object
                                  required
                                  class="required"
                                ></v-select>
                              </v-flex>

                              <v-menu
                                ref="menu"
                                :close-on-content-click="false"
                                v-model="menu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="date"
                                  label="Fecha de Nacimiento"
                                  prepend-icon="event"
                                  readonly
                                  :rules="[v => !!v || 'nombre es requerido']"
                                  required
                                  class="required"
                                ></v-text-field>
                                <v-date-picker
                                  ref="picker"
                                  v-model="date"
                                  :max="new Date().toISOString().substr(0, 10)"
                                  min="1900-01-01"
                                  @change="dateClose"
                                ></v-date-picker>
                              </v-menu>

                              <v-flex xs12 sm6 md4>
                                <v-checkbox
                                  v-model="editedItem.discapacidad"
                                  label="Discapacidad"
                                  color="orange"
                                  value="1"
                                  hide-details
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-select
                                  v-model="editedItem.genero"
                                  :items="genero"
                                  item-text="valor"
                                  item-value="clave"
                                  label="Género"
                                  persistent-hint
                                  return-object
                                  :rules="[v => !!v || 'El género es requerido']"
                                  required
                                  class="required"
                                ></v-select>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-select
                                  v-model="select_departamento"
                                  :items="departamento"
                                  item-text="nombre"
                                  item-value="codigo"
                                  label="Departamento"
                                  :rules="[v => !!v || 'El departamento es requerido']"
                                  persistent-hint
                                  return-object
                                ></v-select>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-text-field v-model="editedItem.telefono" label="Teléfono/celular"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-select
                                  v-model="select_estado_civil"
                                  :items="estado_civil"
                                  item-text="valor"
                                  item-value="clave"
                                  label="Estado Civil"
                                  persistent-hint
                                  return-object
                                  :rules="[v => !!v || 'Estado civil es requerido']"
                                  required
                                  class="required"
                                ></v-select>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-select
                                  v-model="select_idioma"
                                  :items="idioma"
                                  item-text="valor"
                                  item-value="clave"
                                  label="Idioma"
                                  persistent-hint
                                  return-object
                                  :rules="[v => !!v || 'El idioma es requerido']"
                                  required
                                  class="required"
                                ></v-select>

                                <!-- <v-text-field v-model="editedItem.idioma" label="Idioma:"></v-text-field> -->
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-text-field v-model="editedItem.direccion" label="Dirección"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-select
                                  v-model="select_abogado"
                                  :items="abogado"
                                  item-text="nombre"
                                  item-value="id"
                                  label="Abogado / Psicólogo"
                                  required
                                  :rules="[v => !!v || 'El abogado es requerido']"
                                  class="required"
                                  persistent-hint
                                  return-object
                                ></v-select>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" flat @click.native="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="validate">Guardar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <!-- Detalle de la persona registrada -->
      <v-dialog v-model="dialogDetalle" max-width="700px" persistent>
        <!-- <v-btn slot="activator" color="primary" dark class="mb-2">Nuevo Solicitante</v-btn> -->
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>Datos del solicitante</v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs4>
                  <v-subheader>CI Solicitante:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.ci}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Nombre Solicitante:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.nombres}} {{filaActual.apellidos}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Nacionalidad:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.nacionalidad}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Departamento:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.dpa}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Etnia:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.etnia}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Idioma:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.idioma}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Discapacidad:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.discapacidad}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Estado Civil:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.estado_civil}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Dirección:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.direccion}}</span>
                  </v-card-text>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Teléfonos:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-card-text>
                    <span class="text-sm-left">{{filaActual.telefonos}}</span>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="dialogDetalle=false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- fin del detalle de la persona registrada -->
      <!-- Listado -->
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                color="light-green darken-4"
                class="mr-2"
                @click="visorDetalle(props.item)"
              >visibility</v-icon>
              <span>Detalle del solicitante</span>
            </v-tooltip>
          </td>
          <td>{{ props.item.codigo }}</td>
          <td>{{ props.item.codigo_saj }}</td>
          <td class="text-xs-left">{{ props.item.ci }}</td>
          <td class="text-xs-left">{{ props.item.nombres }}</td>
          <td class="text-xs-left">{{ props.item.apellidos }}</td>
          <td class="text-xs-left">{{ props.item.nacionalidad }}</td>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="info"
          icon="warning"
        >Tu búsqueda para "{{ search }}" no obtuvo resultados</v-alert>
      </v-data-table>
    </div>
  </section>
</template>
<script>
import validate from '@/common/mixins/validate';
export default {
  data: () => ({
    rowsPerPageItems: [15, 30, 50],
    pagination: {
      rowsPerPage: 15
    },
    valid: true,
    dialog: false,
    select_idioma: { valor: 'Castellano', clave: 'CASTELLANO' },
    select_estado_civil: { valor: 'Soltero (a)', clave: 'SOLTERO' },
    select_genero: { valor: 'Femenino', clave: 'FEMENINO' },
    select_departamento: { nombre: 'LA PAZ', codigo: '02' },
    select_abogado: null,
    select_nacionalidad: { valor: 'BOLIVIANA', clave: 'BOLIVIANA' },
    idioma: [],
    estado_civil: [],
    genero: [],
    departamento: [],
    abogado: [],
    nacionalidad: [],
    dialogDetalle: false,
    filaActual: {},
    date: null,
    menu: false,
    search: '',
    mixins: [validate],
    ruleCodigoSaj: [
      v => !!v || 'Codigo SAJ es requerido',
      v => (v && (/^[A-Z]+-\d+-\d{4}$/).test(v)) || 'Formato no valido'
    ],
    ruleJustificacion: [
      v => !!v || 'El campo es requerido'
    ],
    ruleSucursal: [
      v => !!v || 'El campo es requerido'
    ],
    headers: [
      {
        text: 'Accciones',
        align: 'left',
        sortable: false,
        value: 'acciones'
      },
      {
        text: 'Código',
        align: 'left',
        sortable: false,
        value: 'codigo'
      },
      {
        text: 'Código SAJ',
        align: 'left',
        sortable: false,
        value: 'codigo_saj'
      },
      { text: 'Carnet de identidad', value: 'nombres' },
      { text: 'Nombres', value: 'nombres' },
      { text: 'Apellidos', value: 'apellidos' },
      { text: 'Nacionalidad', value: 'nacionalidad' }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      conCodigoSaj: false
    },
    defaultItem: {
      conCodigoSaj: false
    },
    paso: 1,
    sucursales: []
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Datos del Solicitante' : 'Edit Item';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    },
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'));
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.$service['get']('v1/iop/saj/status').then(response => {
        if (!response) {
          this.paso = 2;
        }
      });
      this.listar();
      this.$service['get']('v1/parametricas?grupo=IDIOMA').then(response => {
        if (response) {
          this.idioma = response;
        }
      });
      this.$service['get']('v1/parametricas?grupo=ESTADO_CIVIL').then(
        response => {
          if (response) {
            this.estado_civil = response;
          }
        }
      );
      this.$service['get']('v1/parametricas?grupo=GENERO').then(response => {
        if (response) {
          this.genero = response;
        }
      });
      this.$service['get']('v1/dpas/departamentos').then(response => {
        if (response) {
          this.departamento = response;
          // console.log('response',response);
        }
      });
      this.$service['get']('v1/centros/usuarios?tipo=ABOGADO PSICOLOGO').then(
        response => {
          if (response) {
            this.abogado = response;
          }
        }
      );
      this.$service['get']('v1/parametricas?grupo=NACIONALIDAD').then(
        response => {
          if (response) {
            this.nacionalidad = response;
          }
        }
      );
    },
    listar () {
      this.desserts = [];
      this.$service['get']('v1/usuarios/solicitudes').then(response => {
        if (response) {
          for (let item of response) {
            this.desserts.push({
              ci: item.persona_solicitante.nro_documento,
              nombres: item.persona_solicitante.nombres,
              apellidos: `${item.persona_solicitante.primer_apellido} ${
                item.persona_solicitante.segundo_apellido
              }`,
              codigo: item.codigo,
              codigo_saj: item.codigo_saj,
              nacionalidad: item.persona_solicitante.nacionalidad,
              dpa: item.dpa,
              fecha_solicitud: item.fecha_solicitud,
              idioma: item.idioma,
              etnia: item.etnia,
              telefonos: item.telefonos,
              nivel_instruccion: item.nivel_instruccion,
              discapacidad: item.discapacidad,
              estado_civil: item.estado_civil,
              direccion: item.direccion
            });
          }
        }
      });
    },
    visorDetalle (item) {
      this.filaActual = item;
      this.dialogDetalle = true;
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem (item) {
      const index = this.desserts.indexOf(item);
      confirm('Are you sure you want to delete this item?') &&
        this.desserts.splice(index, 1);
    },

    close () {
      this.limpiarFormulario();
      this.paso = 1;
      this.$service['get']('v1/iop/saj/status').then(response => {
        if (!response) {
          this.paso = 2;
        }
      });
      this.dialog = false;
    },

    dateClose (date) {
      this.$refs.menu.save(date);
      this.menu = false;
    },

    limpiarFormulario () {
      this.select_idioma = { valor: 'Castellano', clave: 'CASTELLANO' };
      this.select_estado_civil = { valor: 'Soltero (a)', clave: 'SOLTERO' };
      this.select_genero = { valor: 'Femenino', clave: 'FEMENINO' };
      this.select_departamento = { nombre: 'LA PAZ', codigo: '02' };
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.select_abogado = null;
      this.date = null;
    },

    validate () {
      if (this.$refs.form.validate()) {
        // this.snackbar = true;
        this.save();
      }
    },

    save () {
      let data = {
        dpa: this.select_departamento.codigo,
        fecha_solicitud: new Date(),
        idioma: this.select_idioma.clave,
        etnia: 'NINGUNO',
        telefonos: this.editedItem.telefono,
        nivel_instruccion: this.editedItem.nivel_instruccion,
        discapacidad: this.editedItem.discapacidad ? 'SI' : 'NO',
        estado_civil: this.select_estado_civil.clave,
        proveido: 'Atender el caso',
        responsable_id: this.select_abogado.id,
        direccion: this.editedItem.direccion,
        codigo_saj: this.editedItem.codigoSaj,
        motivo_orientacion: this.editedItem.descripcion_hecho,
        id_sucursal: this.editedItem.sucursal ? this.editedItem.sucursal.id : null,
        justificacion: this.editedItem.justificacionRecepcion,
        persona_solicitante: {
          nro_documento: this.editedItem.ci,
          nombres: this.editedItem.nombres,
          primer_apellido: this.editedItem.primer_apellido,
          segundo_apellido: this.editedItem.segundo_apellido,
          fecha_nacimiento: this.date,
          telefono: this.editedItem.telefono,
          nacionalidad: this.select_nacionalidad.clave,
          genero: this.select_genero.clave
        }
      };
      this.$service['post']('v1/solicitudes', data).then(response => {
        // const a = {
        //   ci: this.editedItem.ci,
        //   nombres: this.editedItem.nombres,
        //   apellidos: `${this.editedItem.primer_apellido} ${
        //     this.editedItem.segundo_apellido
        //   }`,
        //   codigo: response.codigo,
        //   nacionalidad: this.select_nacionalidad.clave
        // };
        // this.desserts.push(a);
        this.listar();
        this.close();
      });
    },

    limpiarCodigo () {
      this.editedItem = { conCodigoSaj: true };
    },
    consultarRedSaj () {
      this.$service['get'](`v1/iop/saj/sucursales`).then(response => {
        this.sucursales = response.datos.rows;
      });
      if (!this.editedItem.conCodigoSaj) {
        this.paso++;
        return;
      }
      if (this.$refs.formRedSaj.validate()) {
        if (!this.editedItem.sucursal) {
          this.$service['get'](`v1/iop/caso-saj/${this.editedItem.codigoSaj}`).then(response => {
            if (response) {
              this.$message.success('Recuperacion de datos exitosa');
              const data = response.datos;
              this.editedItem = {
                ci: data.solicitante.numeroDocumento,
                nombres: data.solicitante.nombres,
                primer_apellido: data.solicitante.primerApellido,
                segundo_apellido: data.solicitante.segundoApellido,
                telefono: data.solicitante.celular || null,
                direccion: data.domicilio.direccion || null,
                genero: data.solicitante.genero,
                descripcion_hecho: data.descripcionHecho,
                codigoSaj: this.editedItem.codigoSaj,
                conCodigoSaj: true,
                idSucursal: data.idSucursal,
                entidad: data.entidad,
                reasignacion: data.reasignacion,
                servicio: data.servicio
              };
              this.date = data.solicitante.fechaNacimiento;
              this.editedItem.sucursal = data.sucursal;
              this.editedItem.sucursalAsignada = data.sucursal;
              if (data.reasignacion) {
                this.editedItem.sucursal = null;
              }
            }
          });
        } else {
          this.paso++;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/casos/registro/Registro.vue